// SearchBar.tsx
import React from "react";
import { View, TextInput } from "react-native";
import { Search } from "lucide-react-native";
import { menuScreenStyles } from "../styles/styles";

interface SearchBarProps {
  value: string;
  onChangeText: (text: string) => void;
  placeholder?: string;
  containerStyle?: object;
  inputStyle?: object;
  iconColor?: string;
  iconSize?: number;
}

export const SearchBar = ({
  value,
  onChangeText,
  placeholder = "Search",
  containerStyle,
  inputStyle,
  iconColor = "#666",
  iconSize = 20,
}: SearchBarProps) => {
  return (
    <View style={[menuScreenStyles.searchContainer, containerStyle]}>
      <Search size={iconSize} color={iconColor} />
      <TextInput
        style={[menuScreenStyles.searchInput, inputStyle]}
        placeholder={placeholder}
        placeholderTextColor={iconColor}
        value={value}
        onChangeText={onChangeText}
        selectionColor={iconColor}
        cursorColor={iconColor}
      />
    </View>
  );
};
